import { Breadcrumb } from '../../types';

export const jobBreadcrumbs: Map<string, Breadcrumb> = new Map([
	[
		'jobDraft',
		{
			name: 'jobDaft',
			to: '/jobs/draft',
			i18nKey: 'breadcrumb.jobDraft',
		},
	],
	[
		'jobCurrent',
		{
			name: 'jobCurrent',
			to: '/jobs/current',
			i18nKey: 'breadcrumb.jobCurrent',
		},
	],
	[
		'jobAll',
		{
			name: 'jobAll',
			to: '/jobs/all',
			i18nKey: 'breadcrumb.jobAll',
		},
	],
	[
		'serviceHoursQrCodeScannerCheckin',
		{
			name: 'serviceHoursQrCodeScannerCheckin',
			i18nKey: 'breadcrumb.serviceHoursQrCodeScannerCheckin',
		},
	],
	[
		'serviceHoursQrCodeScannerCheckout',
		{
			name: 'serviceHoursQrCodeScannerCheckout',
			i18nKey: 'breadcrumb.serviceHoursQrCodeScannerCheckout',
		},
	],
	[
		'jobApplications',
		{
			name: 'jobApplications',
			i18nKey: 'breadcrumb.jobApplications',
		},
	],
	[
		'jobApplicationScanProfile',
		{
			name: 'jobApplicationScanProfile',
			i18nKey: 'breadcrumb.jobApplicationScanProfile',
		},
	],
	[
		'addJobApplicationContactSearch',
		{
			name: 'addJobApplicationContactSearch',
			i18nKey: 'breadcrumb.addJobApplicationContactSearch',
		},
	],
	[
		'jobAttendanceImport',
		{
			name: 'jobAttendanceImport',
			i18nKey: 'breadcrumb.jobAttendanceImport',
		},
	],
	[
		'jobAttendanceImportContactSearch',
		{
			name: 'jobAttendanceImportContactSearch',
			i18nKey: 'breadcrumb.jobAttendanceImportContactSearch',
		},
	],
	[
		'jobAttendanceImportContactSelect',
		{
			name: 'jobAttendanceImportContactSelect',
			i18nKey: 'breadcrumb.jobAttendanceImportContactSelect',
		},
	],
	[
		'addJobApplication',
		{
			name: 'addJobApplication',
			i18nKey: 'breadcrumb.addJobApplication',
		},
	],
	[
		'serviceHours',
		{
			name: 'serviceHours',
			to: '/jobs/service-hours',
			i18nKey: 'breadcrumb.serviceHours',
		},
	],
	[
		'allTimeslots',
		{
			name: 'allTimeslots',
			i18nKey: 'breadcrumb.allTimeslots',
		},
	],
	[
		'jobAttendanceAttendanceList',
		{
			name: 'jobAttendanceAttendanceList',
			i18nKey: 'breadcrumb.jobAttendanceAttendanceList',
		},
	],
]);
